import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";
import { RootState } from "reducers";
import { IConsumable } from "../domain/IConsumable";
import { DailyTableService } from "../services/dt.service";

interface dtConsumablesState {
  loading: boolean;
  consumables: IConsumable[];
  error: any;
}

const initialState: dtConsumablesState = {
  loading: false,
  consumables: [],
  error: undefined,
};

export const getBasicConsumablesData = createAsyncThunk(
  "DailyTable/getBasicConsumablesData",
  async (data?: IDateRangeRequestParams) => {
    try {
      const result = await DailyTableService.getBasicConsumablesData(data);
      return result.consumables;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtConsumablesSlice = createSlice({
  name: "Consumables",
  initialState: initialState,
  reducers: {
    setConsumables: (state, action: PayloadAction<IConsumable[]>) => {
      state.consumables = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBasicConsumablesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBasicConsumablesData.fulfilled, (state, action) => {
      state.consumables = action.payload ? action.payload : [];
      state.loading = false;
    });
    builder.addCase(getBasicConsumablesData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.dailytable.consumables;

export const { setError } = dtConsumablesSlice.actions;

export default dtConsumablesSlice.reducer;
